import common from '@page/common/js/common';
import RenderProductListContent from '@page/productListStatic/js/ProductListContent';
import './HorizontalScrolling';

require('sticky-kit/dist/sticky-kit');

window.pazzo.productConfig = {
  stickyListMenu: true,
  templateVersion: 1,
  hasWishList: true,
  sizeSelectorTypeDesktop: 'dropdown',
  imageBasePath: '//cdn.pazzo.com.tw/',
  zoomboxData: 'JumboImage',
  moreJumboImage: '.product-photos__images',
  imageRenderType: 'sliceFirst',
  refreshDOMs: ['.product-photos__jumbo', '.product-photos__images', '.product-size'],
};

RenderProductListContent();
